import { css } from '@emotion/react';
import styled from '@emotion/styled';
import { Chip, ListItemButton, ListItemIcon, ListItemText, Stack } from '@mui/material';

import { theme } from '@/theme';

export const StyledListItemButton = styled(ListItemButton)<{ selected?: boolean; component?: string; href?: string }>`
    padding-top: 4px;
    padding-bottom: 4px;
    align-items: center;

    .list-item-icon svg,
    .MuiListItemText-root span {
        transition: all ease-out 0.077s;
        ${({ selected }) =>
            selected &&
            css`
                color: ${theme.palette.common.white};
                transform: scale(1.1);
            `}
    }

    :hover {
        background-color: inherit;

        .list-item-icon svg,
        .MuiListItemText-root span {
            color: ${theme.palette.common.white};
            transform: scale(1.1);
        }
    }
`;

export const StyledLoaderStack = styled(Stack)`
    margin-right: 0.8rem;
    width: 1.2rem;
    color: #9e9e9e;

    .MuiLinearProgress-root {
        border-radius: 0.5rem;
        background-color: white;
    }
`;

export const StyledLabelWrapper = styled.div`
    z-index: 1;
    display: flex;
    align-items: center;
    gap: 12px;
`;

export const StyledChip = styled(Chip)`
    min-width: 30px;
    background-color: ${theme.palette.components.chipBg};
    color: ${theme.palette.common.white};
    font-size: ${theme.typography.bodySm.fontSize};
    line-height: ${theme.typography.bodySm.lineHeight};
    font-weight: ${theme.typography.bodySm.fontWeight};

    .MuiChip-label {
        padding: 0 4px;
    }
`;

export const StyledListItemIcon = styled.div`
    display: inline-flex;
    min-width: 56px;
    color: ${theme.palette.components.icon};

    > span {
        justify-content: center;
        width: 22px !important;
    }
`;

export const StyledListItemContent = styled(ListItemIcon)`
    width: 80%;
    display: flex;
    align-items: center;
    justify-content: space-between;
`;

export const StyledListItemText = styled(ListItemText)`
    span {
        color: ${theme.palette.components.icon};
        font-size: 1.2rem;
        font-weight: 500;
        line-height: 1.8rem;
        letter-spacing: 0rem;
        text-align: left;
    }
`;
